import { render, staticRenderFns } from "./Clamping.vue?vue&type=template&id=1d012f14&scoped=true"
import script from "./Clamping.vue?vue&type=script&lang=js"
export * from "./Clamping.vue?vue&type=script&lang=js"
import style0 from "./Clamping.vue?vue&type=style&index=0&id=1d012f14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d012f14",
  null
  
)

export default component.exports